import { DEFAULT_THUMBNAIL_SIZES } from '@features/categories/const';
import { IThumbnailFormats, IThumbnailSrcSet } from '@features/categories/typescript';
import encodeSrcSetUrl from '@utils/encodeSrcSetUrl';
export const THUMBNAIL_FORMAT_PRIORITY: Array<keyof IThumbnailFormats> = ['webp', 'avif', 'jpg'];
export const buildThumbnailSrcSet = (srcSet?: IThumbnailSrcSet): string | undefined => {
  if (!srcSet) return undefined;
  const parts: string[] = [];
  if (srcSet['1x']) parts.push(`${encodeSrcSetUrl(srcSet['1x'])} 1x`);
  if (srcSet['2x']) parts.push(`${encodeSrcSetUrl(srcSet['2x'])} 2x`);
  return parts.length > 0 ? parts.join(', ') : undefined;
};
export const hasThumbnailFormats = (formats?: IThumbnailFormats): boolean => Boolean(formats && (formats.webp || formats.avif || formats.jpg));
export const getThumbnailFallbackUrl = (formats: IThumbnailFormats | null | undefined, fallbackUrl = ''): string => {
  if (!formats) return fallbackUrl;
  for (const format of THUMBNAIL_FORMAT_PRIORITY) {
    const url = formats[format]?.['1x'] || formats[format]?.['2x'];
    if (url) return url;
  }
  return fallbackUrl;
};
export const resolveThumbnailFormats = (thumbnails?: Record<string, IThumbnailFormats | undefined>, sizes: string[] = DEFAULT_THUMBNAIL_SIZES): IThumbnailFormats | undefined => {
  if (!thumbnails) return undefined;
  for (const size of sizes) {
    const formats = thumbnails[size];
    if (hasThumbnailFormats(formats)) return formats;
  }
  return undefined;
};

/** URL dla atrybutu `src` w `<picture>` — preferuje formaty uniwersalnie wspierane przez przeglądarki. */
export const getThumbnailImgSrc = (formats: IThumbnailFormats, fallbackUrl = ''): string => formats.jpg?.['1x'] || formats.jpg?.['2x'] || formats.webp?.['1x'] || formats.webp?.['2x'] || formats.avif?.['1x'] || formats.avif?.['2x'] || getThumbnailFallbackUrl(formats, fallbackUrl);